import React, { useState } from 'react';
import Navigation from './components/Navigation/Navigation';
import Footer from './components/Footer/Footer';
import HomePage from './pages/Home/Home';
import AboutPage from './pages/About/About';
import ContactPage from './pages/Contact/Contact';
import CareersPage  from './pages/Careers/Careers';
import DirectorsPage from './pages/Directors/Directors1';
import './App.css';

const App = () => {
  const [currentPage, setCurrentPage] = useState('home');

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage />;
      case 'about':
        return <AboutPage />;
      case 'contact':
        return <ContactPage />;
      case 'careers':
        return <CareersPage/>;
      case 'directors':
        return <DirectorsPage/>;
      default:
        return <HomePage />;
    }
  };

  return (
    <div className="app">
      <Navigation currentPage={currentPage} setCurrentPage={setCurrentPage} />
      {renderPage()}
      <Footer />
    </div>
  );
};

export default App;